import React, { Component } from 'react';
import { Pagination, Form, Input, Button, Table, DatePicker } from 'antd';
import { ConfigProvider, Icon, Breadcrumb, Tag, Modal, Checkbox } from 'antd';
import { Select } from 'antd';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
import { Translation, withTranslation } from 'react-i18next';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import TableEmpty from '../components/TableEmpty.js';
import throttle from 'lodash.throttle';

import { getSex, formatDA, breadBack, getDay } from '../utils';
import { changeListWidth, getInstitutionOptions, ReviewIcon } from '../utils';
import { formatFromTime, formatToTime, getProvinceOption } from '../utils';
import { FileLineicon, setScrollTop, institutionRecord } from '../utils';
import { getArea, calcTableHeight, showMoreSearch } from '../utils';
import { fastDateOption, breadItem, autoFresh, setSearchInfo } from '../utils';
import { loadingOptionsHtml, timeCalc } from '../utils';
import '../feedback/feedback.css';
import FeedBackModal from './FeedBackModal';
const { Option } = Select;
let autoRefreshReview = '';

const initState = {
  page: 1,
  sortBy: '',
  sort: '',
  patName: '',
  timeTypeVal: false,
  defineTimeType: false,
  confirmedCode: undefined,
  referral: undefined,
  institutionId: undefined,
  areaProvince: undefined,
  recentDays: 2,
  dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
  uploadType: 9,
};

class FeedbackForm extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    setCurrentSearchInfoData: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = initState;

    this.dialogForm = React.createRef();
    this.throttledAiHis = throttle(newState => {
      this.getAihis(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //滚动条重置到顶部
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  async componentDidMount() {
    const roleInfo = window.store.getState().api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.setState({
      isAnonymity,
      tableHeight: 0,
      loadingIconShow: false,
      searchLoading: false,
      autoRefreshStatus: false,
      total: 0,
      i18nextLng: 'zh-CN',
      listWidth: 'calc(87% - 8px)',
      dialogVisible: false,
      dialogType: 1,
      feedbackType: 0,
      dialogDetails: '',
      dialogtype2: '',
      aihisList: [],
      moreFilter: true,
      showMoreFilter: false,
    });
    this.getProvinceList();
    this.getInstitutionData();
    this.pageInit();
    let _this = this;
    window.addEventListener('resize', function() {
      _this.formResize();
    });
    this.formResize();
  }

  componentDidUpdate() {
    // const currentLang = window.localStorage.getItem('i18nextLng');
    // if (currentLang !== this.state.i18nextLng) {
    //   this.setState({
    //     i18nextLng: currentLang,
    //   });
    // }
  }

  pageInit = () => {
    const api = window.store.getState().api;
    const searchInfo = api.current.searchInfo;
    let state = searchInfo.feedbacklist;
    state.defineTimeType = state.timeTypeVal;
    const newState = Object.assign({}, initState, state);
    this.throttledAiHis(newState);

    //从内在中读取是否开启自动刷新
    api.current.searchInfo = api.current.searchInfo || {};
    const status = api.current.searchInfo.autoRefreshStatus || false;
    this.reFreshList(status);
  };

  //自动刷新列表
  reFreshList = status => {
    this.setState({ autoRefreshStatus: status });
    const _this = this;
    if (status) {
      autoRefreshReview = setInterval(function() {
        if (!document.getElementById('reviewForm'))
          clearInterval(autoRefreshReview);
        else _this.throttledAiHis();
      }, 10000);
    } else {
      clearInterval(autoRefreshReview);
    }
  };

  //获取列表
  getAihis = newState => {
    const rows = 20;
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      patName: updatedState.patName,
      chestPa: '', //部位 true正位胸片， false，其他
      areaProvince: updatedState.areaProvince, //省份
      state: [], // 状态 -1免审，10待审，20审核中，30已审---用不上
      imageResult: '', // 肺结核筛查 0阴性，1阳性
      confirmedCode: updatedState.confirmedCode, // 转诊结果  0正常，1肺结核，2其他疾病
      referralState: updatedState.referral, //是否转诊
      sort: 'desc', // "desc"（倒叙）,"asc"（正序）
      institutionId: updatedState.institutionId, //机构id
      sortBy: 'referralState', //排序字段
      pageSize: rows,
      pageNum: updatedState.page,
    };

    if (updatedState.defineTimeType) {
      if (updatedState.dayRange) {
        post.fromTime = formatFromTime(updatedState.dayRange);
        post.toTime = formatToTime(updatedState.dayRange);
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    } else {
      if (updatedState.recentDays !== undefined) {
        const dayRange = timeCalc(updatedState.recentDays);
        post.fromTime = dayRange.fromTime;
        post.toTime = dayRange.toTime;
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    }

    apis.referralList(post).then(result => {
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (result.code === '0') {
        const data = result.data;
        this.setState({ aihisList: data.list, total: data.total });
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        this.setState({ aihisList: [], total: 0 });
      }
    });
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const confirmedCode = values.confirmedCode;
        const referralState = values.referralState;
        const newState = {
          institutionId: (values.name || []).join(','),
          patName: values.patName,
          page: 1,
          loadingIconShow: true,
          searchLoading: true,
          areaProvince: values.provice,
          confirmedCode:
            confirmedCode !== undefined ? Number(confirmedCode) : undefined, // 转诊结果  0正常，1肺结核，2其他疾病
          referral:
            referralState !== undefined ? Number(referralState) : undefined, //是否转诊
          dayRange: values.dayRange,
          recentDays: values.recentDays,
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,
        };

        this.throttledAiHis(newState);
        setSearchInfo(newState, 'feedbacklist', this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const loadingState = { searchLoading: true };
    const newState = Object.assign({}, initState, loadingState);
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledAiHis(newState);
    setSearchInfo(initState, 'feedbacklist', this);
    setScrollTop();
  };

  getStatusName = status => {
    const statusArray = [
      { value: '0', label: '待审核', color: '#F4A237' },
      { value: '1', label: '审核中', color: '#559ACD' },
      { value: '2', label: '已审核', color: '#559ACD' },
      { value: '3', label: '已打印', color: '#559ACD' },
    ];
    let tagHtml;
    statusArray.map(item => {
      if (item.value === status)
        tagHtml = <Tag color={item.color}>{item.label}</Tag>;
      return item;
    });
    return tagHtml;
  };
  feedBackTdSelect = (data, val) => {
    const newList = JSON.parse(JSON.stringify(this.state.aihisList));
    newList.map(item => {
      if (val === '其他部位') {
        if (item.id === data.id) item['oldImageResult'] = '';
      } else {
        if (item.id === data.id) item['oldImageResult'] = data.imageResult;
      }
      return '';
    });
    this.setState({ aihisList: newList });
  };
  unique(arr) {
    const res = new Map();
    return arr.filter(arr => !res.has(arr.chestPa) && res.set(arr.chestPa, 1));
  }
  //获取是否是正位胸片
  getChestPa = (dicomList, data) => {
    let arr = [];
    let max = 0;
    dicomList.forEach(item => {
      if (item.chestPa === true) {
        max = item.confidence > max ? item.confidence : max;
        if (item.confidence >= max) {
          arr = [];
          arr.push(item);
        }
      }
    });

    dicomList.forEach(item => {
      if (item.chestPa === false) arr = arr.concat([item]);
    });

    arr = this.unique(arr);

    let defaultValue = '';
    let colorType = '';
    if (arr[0].chestPa) {
      colorType = 'type1';
      defaultValue = '正位胸片';
    } else {
      colorType = 'type2';
      defaultValue = '其他部位';
    }

    if (arr.length > 1) {
      return (
        <Select
          size="small"
          defaultValue={defaultValue}
          style={{ width: 90 }}
          onChange={this.feedBackTdSelect.bind(this, data)}
          // className={`feedBack-td-select ${colorType}`}
          bordered={false}
        >
          {arr.map(item => (
            <Option
              value={item.chestPa ? '正位胸片' : '其他部位'}
              key={item.sopInstanceId}
            >
              {item.chestPa ? '正位胸片' : '其他部位'}
            </Option>
          ))}
        </Select>
      );
    } else if (arr.length === 1) {
      return (
        <span
          className={
            colorType === 'type1' ? 'text-tag-chestpa' : 'text-tag-other'
          }
        >
          {arr[0].chestPa ? '正位胸片' : '其他部位'}
        </span>
      );
    } else {
      return '— —';
    }
  };

  // 肺结核筛查状态
  getChestState = (code, list) => {
    let state = list.oldImageResult === '' ? list.oldImageResult : code;
    if (state === 0) {
      return <Tag color="#77c565">{'结核影像阴性'}</Tag>;
    } else if (state === 1) {
      return <Tag color="#ff5500">{'结核影像阳性'}</Tag>;
    } else {
      return '— —';
    }
  };

  //
  getFeedbackState = code => {
    if (code === 0) {
      return <span style={{ color: '#DC2F2F' }}>{'未转诊'}</span>;
    } else if (code === 1) {
      return <span style={{ color: '#000000' }}>{'已转诊'}</span>;
    } else if (code === 2) {
      return <span style={{ color: '#000000' }}>{'已截止'}</span>;
    } else {
      return '— —';
    }
  };
  getFeedbackResult = code => {
    if (code === 0) {
      return <span style={{ color: '#000000' }}>{'正常'}</span>;
    } else if (code === 1) {
      return <span style={{ color: '#DC2F2F' }}>{'肺结核'}</span>;
    } else if (code === 2) {
      return <span style={{ color: '#DC2F2F' }}>{'其他疾病'}</span>;
    } else {
      return '— —';
    }
  };

  //分页
  pageOnChange = (page, pageSize) => {
    setScrollTop();
    const newState = { page, searchLoading: true };
    this.throttledAiHis(newState);
  };

  //获取机构列表
  getInstitutionData = async (name, area) => {
    const data = await institutionRecord(name, area);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  //查看详情
  viewHeatmap = item => {
    item.subVos = item.dicomList;
    this.props.setApplicationData(item);

    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;

    const studyUid = item.studyUid;
    let url = `/viewer/study/${studyUid}?tubeId=${item.id}&from=screening&from1=view`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width${xpwidth},height=${xpheight}`;
    window.open(url, 'viewer', str);
  };

  getColumns = () => {
    const { isAnonymity } = this.state;
    const columns = [];
    columns.push(
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: 170,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: 80,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: 80,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },

      {
        title: '部位',
        dataIndex: 'dicomList',
        key: 'dicomList',
        width: 150,
        className: 'feedTag',
        render: (dicomList, data) => (
          <div>{this.getChestPa(dicomList, data)}</div>
        ),
      },
      {
        title: '肺结核筛查',
        dataIndex: 'imageResult',
        key: 'imageResult',
        width: 200,
        render: (list, imageResult) => (
          <div>
            {this.getChestState(list, imageResult)}
            <Button
              className="btn-feedback-viewer"
              title="查看影像"
              onClick={this.viewHeatmap.bind(this, imageResult)}
            >
              <FileLineicon />
            </Button>
          </div>
        ),
      },
      {
        title: '转诊反馈',
        dataIndex: 'referralState',
        key: 'referralState',
        width: 120,
        render: referralState => (
          <div>{this.getFeedbackState(referralState)}</div>
        ),
      },
      {
        title: '转诊结果',
        dataIndex: 'confirmedCode',
        key: 'confirmedCode',
        width: 120,
        render: confirmedCode => (
          <div>{this.getFeedbackResult(confirmedCode)}</div>
        ),
      },
      {
        title: '上传时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 200,
        render: createTime => <span>{formatDA(createTime)}</span>,
      },
      {
        title: '机构',
        dataIndex: 'institutionName',
        key: 'institutionName',
        // width: 330,
        render: value => <span>{isAnonymity ? '***' : value || '--'}</span>,
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'id',
        align: 'left',
        // width: '15%',
        width: 150,
        fixed: 'right',
        render: list => <>{this.getButtons(list)}</>,
      }
    );

    return columns;
  };
  getButtons = record => {
    const confirmedCode = record.confirmedCode;
    const status = record.referralState;

    const buttons = [];
    if (status === 0) {
      buttons.push(
        <Button
          type="link"
          key={`btn${record.id}`}
          className="btn-viewdetail"
          onClick={this.changeDialogModel.bind(this, {
            flag: true,
            type: 1,
            record: record,
          })}
        >
          <ReviewIcon />
          转诊
        </Button>
      );
    } else if (status === 1) {
      confirmedCode !== 3
        ? buttons.push(
            <Button
              type="link"
              key={`btn${record.id}1`}
              className="btn-viewdetail"
              onClick={this.changeDialogModel.bind(this, {
                flag: true,
                type: 2,
                dialogtype2: 1,
                record: record,
              })}
            >
              <ReviewIcon />
              编辑
            </Button>,
            <Button
              type="link"
              key={`btn${record.id}2`}
              className="btn-viewdetail"
              onClick={this.changeDialogModel.bind(this, {
                flag: true,
                type: 4,
                record: record,
              })}
            >
              <Icon type="eye" theme="filled" />
              查看
            </Button>
          )
        : buttons.push(
            <Button
              type="link"
              key={`btn${record.id}`}
              className="btn-viewdetail"
              onClick={this.changeDialogModel.bind(this, {
                flag: true,
                type: 2,
                record: record,
              })}
            >
              <ReviewIcon />
              反馈
            </Button>
          );
    } else {
      buttons.push(
        <Button
          type="link"
          key={`btn${record.id}`}
          onClick={this.changeDialogModel.bind(this, {
            flag: true,
            type: 3,
            record: record,
          })}
          className="btn-viewdetail"
          disabled={false}
        >
          <Icon type="eye" theme="filled" />
          查看
        </Button>
      );
    }
    return buttons;
  };

  handleChangeProvince = value => {
    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };
  // 获取省份列表
  getProvinceList = async () => {
    const data = await getArea(0);
    this.setState({ provinceList: data });
  };
  changeDialogModel(obj) {
    this.setState(
      {
        dialogVisible: obj.flag,
        dialogType: obj.type,
        dialogDetails: obj.record,
        dialogtype2: obj.dialogtype2,
      },
      () => {
        this.setState({ feedbackType: 0 });
      }
    );
  }
  onChangeRadio = values => {
    this.setState({ feedbackType: values.target.value });
  };
  reSetList() {
    this.getAihis();
  }

  setTimeType = e => {
    this.setState({ timeTypeVal: e.target.checked });
  };
  setFreshEvent = e => {
    // if (e.target.checked) this.setSearchEvent('ns-062');
    // else this.setSearchEvent('ns-063');
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    let { aihisList, institutionData, dialogVisible, tableHeight } = this.state;
    let { institutionId, patName, areaProvince, confirmedCode } = this.state;
    let { referral, timeTypeVal, recentDays, dayRange } = this.state;
    let { isAnonymity, i18nextLng, moreFilter, showMoreFilter } = this.state;

    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';
    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);
    let screenWidth = parseInt(document.body.clientWidth * 0.87 - 60);
    let tableWidth = 1470;
    if (screenWidth > tableWidth) tableWidth = screenWidth;

    return (
      <Translation>
        {t => (
          <div className="form-bg" id="reviewForm">
            <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />
            <div className="theme-content">
              <ConnectedHeader
                toggleCollapsed={changeListWidth.bind(this, this)}
                login={false}
                home={true}
              />
              <div className="theme-box">
                <div className="bread-crumb">
                  <Breadcrumb>
                    {breadItem(['转诊追踪', '肺结核转诊反馈'])}
                  </Breadcrumb>
                  {breadBack(this)}
                  {autoFresh(this)}
                </div>
                <div className="box" style={{ width: this.state.listWidth }}>
                  <div className="left">
                    <Form
                      className={`ant-advanced-search-form${
                        !moreFilter && showMoreFilter ? ' notOverflow' : ''
                      }`}
                      onSubmit={this.handleSearch}
                      layout="inline"
                    >
                      <div className="searchBox">
                        <div className="searchBoxContent">
                          {/* 上传时间 */}
                          <div className="search-unit">
                            <Form.Item
                              style={{
                                display: timeTypeVal === true ? '' : 'none',
                              }}
                              label={t('uploadTime')}
                              colon={false}
                            >
                              <ConfigProvider
                                locale={i18nextLng === 'zh-CN' ? zh_CN : null}
                              >
                                {getFieldDecorator('dayRange', {
                                  initialValue:
                                    from && to
                                      ? [
                                          moment(from, dateFormat),
                                          moment(to, dateFormat),
                                        ]
                                      : null,
                                })(
                                  <RangePicker
                                    format={dateFormat}
                                    allowClear={true}
                                    placeholder={[t('startDate'), t('endDate')]}
                                    style={{ width: 240 }}
                                  />
                                )}
                              </ConfigProvider>
                            </Form.Item>
                            <Form.Item
                              style={{
                                display: timeTypeVal === true ? 'none' : '',
                              }}
                              label={t('uploadTime')}
                              colon={false}
                            >
                              {getFieldDecorator('recentDays', {
                                initialValue: recentDays,
                              })(
                                <Select
                                  defaultActiveFirstOption={true}
                                  showArrow={false}
                                  filterOption={false}
                                  allowClear={true}
                                  style={{ width: 240 }}
                                >
                                  {fastDateOption()}
                                </Select>
                              )}
                            </Form.Item>
                            <Form.Item label="" colon={false}>
                              {getFieldDecorator('defineTimeType', {})(
                                <Checkbox
                                  checked={timeTypeVal}
                                  onChange={this.setTimeType}
                                >
                                  自定义
                                </Checkbox>
                              )}
                            </Form.Item>
                          </div>
                          {/* 机构 */}
                          <div className="search-unit">
                            <Form.Item
                              label="机构"
                              colon={false}
                              className="form-provice"
                            >
                              {getFieldDecorator('provice', {
                                initialValue: areaProvince,
                              })(
                                <Select
                                  showSearch
                                  placeholder="选择省份"
                                  defaultActiveFirstOption={false}
                                  filterOption={false}
                                  showArrow={false}
                                  onChange={this.handleChangeProvince}
                                  notFoundContent={null}
                                  allowClear={true}
                                  style={{ width: 110 }}
                                  disabled={isAnonymity}
                                >
                                  {getProvinceOption(this.state.provinceList)}
                                </Select>
                              )}
                            </Form.Item>
                            <Form.Item
                              label=""
                              colon={false}
                              className="form-institute"
                            >
                              {getFieldDecorator('name', {
                                initialValue: institutionId,
                              })(
                                <Select
                                  className="institution-selection"
                                  showSearch
                                  mode="multiple"
                                  placeholder={t('enterInstitutionName')}
                                  defaultActiveFirstOption={false}
                                  showArrow={false}
                                  filterOption={false}
                                  onSearch={this.handleInstitutionSearch}
                                  onChange={this.handleChange}
                                  allowClear={true}
                                  style={{ width: 190 }}
                                  disabled={isAnonymity}
                                >
                                  {institutionOptions}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          {/* 姓名 */}
                          <Form.Item label={t('name')} colon={false}>
                            {getFieldDecorator('patName', {
                              initialValue: patName,
                            })(
                              <Input
                                allowClear={true}
                                style={{ width: 160 }}
                                placeholder={t('enterSubjectName')}
                                disabled={isAnonymity}
                              />
                            )}
                          </Form.Item>

                          {/* 转诊反馈 */}
                          <Form.Item label={'转诊反馈'} colon={false}>
                            {getFieldDecorator('referralState', {
                              initialValue: referral,
                            })(
                              <Select
                                placeholder="请选择"
                                allowClear={true}
                                style={{ width: 170 }}
                              >
                                <Option value={0}>未转诊</Option>
                                <Option value={1}>已转诊</Option>
                                <Option value={2}>已截止</Option>
                              </Select>
                            )}
                          </Form.Item>

                          {/* 转诊结果 */}
                          <Form.Item label={'转诊结果'} colon={false}>
                            {getFieldDecorator('confirmedCode', {
                              initialValue: confirmedCode,
                            })(
                              <Select
                                placeholder="请选择"
                                allowClear={true}
                                style={{ width: 170 }}
                              >
                                <Option value={0}>正常</Option>
                                <Option value={1}>肺结核</Option>
                                <Option value={2}>其他疾病</Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </div>
                      <div className="searchOptBox">
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btn-search"
                            disabled={this.state.searchLoading}
                          >
                            {this.state.loadingIconShow ? (
                              <Icon type="sync" spin />
                            ) : (
                              <Icon type="search" />
                            )}
                            {t('search')}
                          </Button>
                          <Button
                            style={{ marginLeft: 8 }}
                            icon="redo"
                            className="btn-reset"
                            disabled={this.state.searchLoading}
                            onClick={this.handleReset}
                          >
                            {t('reset')}
                          </Button>
                        </Form.Item>
                        {this.state.showMoreFilter ? (
                          <Button
                            type="link"
                            className="moreFilter"
                            onClick={() =>
                              this.setState({ moreFilter: !moreFilter })
                            }
                            icon={moreFilter ? 'down' : 'up'}
                          >
                            {moreFilter ? '展开' : '收起'}
                          </Button>
                        ) : null}
                      </div>
                    </Form>
                    <div className="history-list">
                      <Table
                        loading={loadingOptions}
                        columns={columns}
                        dataSource={aihisList}
                        rowKey={record => record.id}
                        key={record => record.id}
                        pagination={false}
                        className="list-item"
                        scroll={{ y: tableHeight, x: tableWidth }}
                        locale={{ emptyText: <TableEmpty /> }}
                        onChange={(pagination, filters, sorter) => {
                          const orderType = { descend: 'DESC', ascend: 'ESC' };
                          const sortType = orderType[sorter.order];
                          const orderField = sorter.columnKey || '';
                          const newState = {
                            page: 1,
                            sortBy: orderField,
                            sort: sortType,
                            searchLoading: true,
                          };
                          this.throttledAiHis(newState);
                        }}
                      />
                      <ConfigProvider
                        locale={i18nextLng === 'zh-CN' ? zh_CN : null}
                      >
                        <Pagination
                          onChange={this.pageOnChange}
                          total={this.state.total}
                          pageSize={20}
                          className="list-page"
                          current={this.state.page}
                          showQuickJumper
                          size="small"
                          showTotal={() => `共${this.state.total}条`}
                        ></Pagination>
                      </ConfigProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              title="转诊反馈"
              centered
              visible={dialogVisible}
              onOk={() =>
                this.changeDialogModel({ flag: false, type: 1, record: '' })
              }
              onCancel={() =>
                this.changeDialogModel({ flag: false, type: 1, record: '' })
              }
              destroyOnClose={true}
              width={450}
              className="feedback-dialog"
              footer={null}
            >
              <FeedBackModal
                {...this.state}
                onChangeRadio={this.onChangeRadio}
                changeDialogModel={this.changeDialogModel.bind(this)}
                reSetList={this.reSetList.bind(this)}
              />
            </Modal>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(
  Form.create()(withTranslation('Common')(FeedbackForm))
);
